"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_BOX_ICONS = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../icons");
const MessageBoxIconView_1 = require("../types/MessageBoxIconView");
exports.MESSAGE_BOX_ICONS = {
    [MessageBoxIconView_1.MESSAGE_BOX_ICON_VIEW.error]: react_1.default.createElement(icons_1.RedCloseIcon, null),
    [MessageBoxIconView_1.MESSAGE_BOX_ICON_VIEW.info]: react_1.default.createElement(icons_1.LargeInfoStatusIcon, null),
    [MessageBoxIconView_1.MESSAGE_BOX_ICON_VIEW.warning]: react_1.default.createElement(icons_1.LargeWarningStatusIcon, null)
};
//# sourceMappingURL=constants.js.map